import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Authenticated from 'Components/Layouts/Authenticated';
import {Loading, Alert, Countdown} from 'Components/Partials';
import {PrimaryButton, DangerButton, SecondaryButton} from 'Components/Button';
import {RenderWYSIWYG} from 'Components/Form';
import {ModalTrigger} from 'Components/Modal';

import AddToCalendarModal from './AddToCalendarModal';

import AgendaApi from 'Services/Api/Agenda/Agenda';
import {Toast} from 'Services';
import {translation} from 'Services/TranslationHelpers';
import {translationFromJson} from 'Services/TranslationHelpers2';
import {resourceDateIsBeforeNow, resourceDateIsAfterNow, dateToString, timeToTwelveHour} from 'Services/DateHelpers';

import SmallButton from "Components/Button/SmallButton";
import RecordApi from "Services/Api/Cms/Elements/Record";
import { getRecordValue } from "Services/CmsHelpers";
import SpeakerModel from "Components/Partials/Modals/SpeakerModel";
import Link from "Components/Utilities/Link";
import {asset} from "Services/BaseHelpers";
import agenda from "Services/Api/Admin/Agenda";
import JoinUs from "Components/Partials/JoinUs";

export default class AgendaIndex extends React.Component {
    /**
     * @var state
     */
    state = {
        loading: true,
        alert: null,
        agendas: null,
        dates: null,
        active_date: null,
        refresh_time: null,
        isCollapse: [],
        expandedAgenda: null, // Track the expanded agenda

    };
    /**
     * @method fetchRecords
     * @return {Promise<void>}
     */
    fetchRecords = async (agenda) => {

        //if not agenda speaker element return
        if (agenda.speakers.length === 0) {
            return;
        }

        this.setState({
            working: true
        });

        const request = await RecordApi.getSpeaker(agenda.id, {
            paginate: this.paginate,
            ...this.state.filters,
            active: 'Yes',
            page: 1,
            order_by: 'created_at',
            order: 'asc'
        });

        if (request.success) {
            return this.setState({
                //mape the speakers to id and value
                speakers: request.data.data.map((speaker) => {
                    let title = getRecordValue(speaker, 'title');
                    let sub_title = getRecordValue(speaker, 'sub_title');
                    let thumbnail = getRecordValue(speaker, 'thumbnail');
                    let content = getRecordValue(speaker, 'content');
                    let company_thumbnail = getRecordValue(speaker, 'company_thumbnail');
                    let job_title = getRecordValue(speaker, 'job_title');

                    return {
                        id: speaker.id,
                        title: title,
                        sub_title: sub_title,
                        thumbnail: thumbnail,
                        content: content,
                        company_thumbnail: company_thumbnail,
                        job_title: job_title,
                    };
                }),
                working: false
            });
        }
        Toast.error();
    };
    /**
     * @method componentDidMount
     */
    componentDidMount = async () => {
        this.getAgenda();

        // Initialize AOS
        AOS.init({
            duration: 500,
            once: true,
            easing: 'ease-in-out',
        });

        // Rerender every 60 seconds in order to keep the action buttons in sync.
        this.refreshInterval = setInterval(() => this.setState({refresh_time: Date.now()}), 60000);
    }

    /**
     * @method componentWillUnmount
     */
    componentWillUnmount = () => {
        clearInterval(this.refreshInterval);
    };

    /**
     * @method getAgenda
     */
    getAgenda = async () => {
        this.setState({
            loading: true
        });

        const request = await AgendaApi.get(null);

        if (request.success) {
            // Get all dates.
            const dates = [...new Set(
                request.data.data.map(agenda => agenda.start_date_time.date_timezone)
            )];

            return this.setState({
                loading: false,
                agendas: request.data.data,
                dates,
                active_date: this.state.active_date ?? dates[0]
            });

            // TODO scroll back to where they were on the page.
        }

        Toast.error();
    };

    /**
     * @method render
     * @return {*}
     */
    render() {
        const {loading, alert, agendas} = this.state;

        return (
            <Authenticated pageTitle="Agenda" pageVideoHeader={ "bupa-banner.mp4" }>
                <div className="relative text-app-blue">
                    <div
                        className="w-full  ml-auto mr-auto max-w-7xl"
                    >
                        <div className=" my-12 text-center text-2xl font-bold mx-auto">
                            {/*<img*/}
                            {/*    src={asset('images/agenda-date-banner.gif')}*/}
                            {/*    alt="Agenda Date Banner"*/}
                            {/*    className="w-full h-24 object-cover mt-2 p-4 max-w-4xl mx-auto"*/}
                            {/*/>*/}
                            Agenda
                        </div>

                        <div className="p-4 text-center max-w-4xl mx-auto">
                            {/*<Link to="/speakers" className="text-app-blue underline">*/}
                            {/*    <SmallButton text={"View All Speakers"}/>*/}
                            {/*</Link>*/}

                            {loading && <Loading/>}

                            {!loading &&
                                <div className={"my-8"}>
                                    {alert &&
                                        <div
                                            className="px-8 py-4 mx-auto"
                                            id="alert"
                                        >
                                            <Alert {...alert} />
                                        </div>
                                    }

                                    {!agendas || agendas.length === 0 &&
                                        <p className="font-bold">
                                            {translation('misc', 'no_items', {
                                                ITEM: translation('agenda', 'agenda')
                                            })}
                                        </p>
                                    }

                                    {agendas && agendas.length !== 0 &&
                                        <div className={""}>
                                            {this.renderAgendas()}
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </Authenticated>
        );
    }

    /**
     * @method renderAgendas
     * @return {*}
     */
    renderAgendas() {
        const { agendas, active_date } = this.state;

        // Filter and sort agendas by start time
        let sortedAgendas = agendas
            .filter(agenda => agenda.start_date_time.date_timezone === active_date)
            .sort((a, b) => new Date(a.start_date_time.datetime) - new Date(b.start_date_time.datetime));

        //we need to resprot the agenda speakers here so that if the name Dr Anne Lepetit or Nigel Sullivan appeaer than place them at the top of the list. here
        sortedAgendas.sort((a, b) => {
            //speakers is an array of speakers and we check if the name is in the array and sort accordingly.
            let speakerNames = [ "Dr Anne Lepetit", "Nigel Sullivan" ];

            // Function to prioritize speakers within an agenda
            const prioritizeSpeakers = (speakers) => {
                return speakers.sort((s1, s2) => {
                    if (speakerNames.includes(getRecordValue(s1, 'title')) && !speakerNames.includes(getRecordValue(s2, 'title'))) {
                        return -1;
                    }
                    if (!speakerNames.includes(getRecordValue(s1, 'title')) && speakerNames.includes(getRecordValue(s2, 'title'))) {
                        return 1;
                    }
                    return 0;
                });
            };

            // Apply the prioritizeSpeakers function to both agendas
            a.speakers = prioritizeSpeakers(a.speakers);
            b.speakers = prioritizeSpeakers(b.speakers);

            // Continue with the existing sorting logic if needed
            return 0; // No change in order of agenda items, only within each item's speakers list
        });

        // Palette of background and strip colors to approximate the design
        // Repeats blue, purple/pink, green in sequence for every agenda item.
        const palette = [
            { bg: '#B3D6EF', strip: '#51A0DC', text: '#00398A' }, // light blue
            { bg: '#e9d6ff', strip: '#B88AF6', text: '#491D8B' }, // light purple/pink (use purple text for contrast)
            { bg: '#A7F0BA', strip: '#6FDC8C', text: '#004144' }, // light green (use green text)
        ];

        return (
            <div className="flex flex-col space-y-6">
                {sortedAgendas.map((agenda, i) => {
                    const colours = palette[i % palette.length];
                    return (
                        <div
                            key={i}
                            className="w-full shadow-md rounded-lg overflow-hidden"
                            data-aos="fade-up"
                            data-aos-delay={i * 50}
                        >
                            <div className="flex items-stretch" style={{ backgroundColor: colours.bg }}>
                                {/* Narrow left coloured strip */}
                                <div className="w-12" style={{ backgroundColor: colours.strip }} />

                                {/* Main card area */}
                                <div className="flex-1 p-6 flex items-start">
                                    {/* Time column */}
                                    <div className="w-36 flex items-center justify-center">
                                        <p className={`text-lg font-medium ${colours.text}`}>
                                            {timeToTwelveHour(agenda.start_date_time.time_timezone)}
                                        </p>
                                    </div>

                                    {/* Vertical divider */}
                                    <div className="w-px mx-6 bg-app-blue" style={{ height: '64px' }} />

                                    {/* Title / Subtitle column */}
                                    <div className="flex-1">
                                        {agenda.sub_title && (
                                            <p className={`text-sm mb-2 ${colours.text} font-medium`}>{agenda.sub_title}</p>
                                        )}
                                        <p className={`${colours.text} text-xl font-semibold leading-tight`}>
                                            {translationFromJson(agenda.title) || '\u00A0'}
                                        </p>
                                    </div>

                                    {/* Vertical divider */}
                                    <div className="w-px mx-6 bg-app-blue" style={{ height: '64px' }} />

                                    {/* Speakers column */}
                                    <div className="w-64 flex flex-col justify-center pr-4">
                                        {agenda.speakers && agenda.speakers.length > 0 ? (
                                            agenda.speakers.map((speaker, si) => {
                                                const titleVal = getRecordValue(speaker, 'title');
                                                const jobVal = getRecordValue(speaker, 'job_title');
                                                const companyVal = getRecordValue(speaker, 'company_name');
                                                const positionLine = [jobVal, companyVal].filter(Boolean).join(', ');
                                                const companyLogo = getRecordValue(speaker, 'company_thumbnail');
                                                const thumb = companyLogo && (companyLogo.url || typeof companyLogo === 'string') ? (companyLogo.url || companyLogo) : null;

                                                return (
                                                    <div key={si} className="flex items-center mb-4 text-left">
                                                        <div className="w-12 h-12 bg-white/20 rounded-sm mr-4 flex-shrink-0 overflow-hidden">
                                                            {thumb ? (
                                                                <img src={thumb} alt={companyVal || titleVal} className="w-full h-full object-contain" />
                                                            ) : (
                                                                <div className="w-full h-full" />
                                                            )}
                                                        </div>

                                                        <div className="flex-1">
                                                            <ModalTrigger component={SpeakerModel} props={{ speaker }}>
                                                                <p className={`font-bold underline cursor-pointer ${colours.text}`}>{titleVal}</p>
                                                            </ModalTrigger>
                                                            {positionLine && <p className={`text-sm ${colours.text}`}>{positionLine}</p>}
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className={colours.text + " text-center"}>
                                                <RenderWYSIWYG content={translationFromJson(agenda.content)}  className={colours.text} />
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
